var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"blue-link d-flex align-items-center",attrs:{"href":"javascript:void(0)","data-toggle":"tab","aria-controls":_vm.tabId},on:{"click":_vm.onActionClick}},[(_vm.tabIcon)?_c('i',{class:['fa', _vm.tabIcon, 'mr-1']}):_vm._e(),_vm._v("\n\t"+_vm._s(_vm.actionLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }